import { CrmDetailName, CrmParentName } from '@apparatix/schemas/Routing';
import { useRoute, useRouter } from 'vue-router';
import { CrmDetailTabName } from './useCrm';

const CRM_PATH_PREFIX = '/crm';

const CORE_PATH_PREFIX = '/core';

export const useRoutingHelpers = () => {
  const router = useRouter();
  const route = useRoute();

  const isCrmPage = () => typeof route?.path === 'string' && route.path.startsWith(CRM_PATH_PREFIX);

  const getParentName = (): CrmParentName => {
    if (!route?.path) return undefined;

    const segments = route.path.split('/');
    if (segments.length < 3) {
      return undefined;
    }

    return segments[2] as CrmParentName;
  };

  const buildCrmDetailPath = (parentType: CrmParentName, detailType: CrmDetailName, detailId: number, tab?: CrmDetailTabName) => tab
    ? `${CRM_PATH_PREFIX}/${parentType}/detail/${detailType}/${detailId}/${tab}`
    : `${CRM_PATH_PREFIX}/${parentType}/detail/${detailType}/${detailId}`;

  // This is a bit duplicitous, but we have a separate route for the same component from CORE
  const buildCoreCrmDetailPath = (parentType: CrmParentName, detailType: CrmDetailName, detailId: number, tab?: CrmDetailTabName) => tab
    ? `${CORE_PATH_PREFIX}/detail/${detailType}/${detailId}/${tab}`
    : `${CORE_PATH_PREFIX}/detail/${detailType}/${detailId}`;

  const openCrmDetailFlyout = async (parent: CrmParentName, detail: CrmDetailName, id: number, tab?: CrmDetailTabName, keepCurrentParent: boolean = true) => {
    const isCoreRoute = router.currentRoute.value.path.startsWith(CORE_PATH_PREFIX);

    if (!isCrmPage() || !keepCurrentParent) {
      const path = isCoreRoute ? buildCoreCrmDetailPath(parent, detail, id, tab) : buildCrmDetailPath(parent, detail, id, tab);

      router.push({ path });
      return;
    }

    const currentParent = getParentName();
    if (!currentParent) {
      return;
    }

    const path = isCoreRoute ? buildCoreCrmDetailPath(currentParent, detail, id, tab) : buildCrmDetailPath(currentParent, detail, id, tab);

    await router.push({ path });
  };

  return {
    openCrmDetailFlyout,
  };
};
